<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <v-btn text class="ui-back-btn" @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-col>
      <v-col cols="5">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center"
            >Registro de capacitación</v-card-title
          >
          <v-card-text>
            <v-form v-model="courseForm">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      class="ui-form-field"
                      v-model="curso.subcategoria"
                      rounded
                      filled
                      dense
                      background-color="transparent"
                      color="secondary"
                      :rules="nameRules"
                    >
                      <template v-slot:label
                        >Subcategoría (nombre de la capacitación) <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="8">
                    <v-select
                      class="ui-form-field"
                      background-color="transparent"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="categories"
                      item-value="id"
                      item-text="categoria"
                      v-model="curso.fk_idCategoria"
                      :rules="nameRules"
                      item-color="secondary"
                    >
                      <template v-slot:label>Categoría <span class="red--text">*</span> </template>
                      <template v-slot:selection="{ item }">
                        <div>
                          <div>{{ item.categoria }}</div>
                          <div class="text-caption">{{ item.CatTipoCurso.title }}</div>
                        </div>
                      </template>
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title>{{ item.categoria }}</v-list-item-title>
                          <v-list-item-subtitle>{{ item.CatTipoCurso.title }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      class="ui-form-field"
                      v-model.number="curso.puntaje"
                      type="number"
                      rounded
                      filled
                      dense
                      background-color="transparent"
                      color="secondary"
                      label="Puntaje"
                      :rules="puntajeRules"
                    >
                      <template v-slot:label>Puntaje <span class="red--text">*</span> </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      class="ui-form-field ui-form-textarea"
                      v-model="curso.observaciones"
                      rounded
                      filled
                      dense
                      background-color="transparent"
                      color="secondary"
                      label="Observaciones"
                      no-resize
                      rows="4"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      class="ui-form-field"
                      v-model="curso.file"
                      label="Adjuntar documento del curso .jpg"
                      rounded
                      filled
                      background-color="transparent"
                      color="secondary"
                      dense
                      ref="file"
                      type="file"
                      id="file"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-center ui-module-actions">
            <v-btn
              color="secondary"
              class="mb-8 ui-module-btn-solid"
              v-on:click="triggerSaveCourse()"
              :loading="loading"
              :disabled="loading || !courseForm"
              >Registrar capacitación</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      courseForm: false,

      curso: {
        nombre: null,
        subcategoria: '',
        fk_idCategoria: null,
        observaciones: '',
        puntaje: 0,
        file: null,
      },

      nameRules: [(v) => !!v || 'Este campo es requerido.'],
      puntajeRules: [(v) => !!v || 'Ingrese un puntaje válido.', (v) => v > 0 || 'Ingrese un puntaje válido.'],
    }
  },

  computed: {
    ...mapGetters('categoriaCurso', {
      categories: 'getCategories',
    }),

    ...mapGetters('tipoCurso', {
      tipoCurso: 'getCourseTypes',
    }),
  },

  methods: {
    ...mapActions('curso', ['saveCurso']),
    ...mapActions('curso', ['fetchCursos']),

    triggerSaveCourse: async function () {
      this.loading = true

      await this.saveCurso(this.curso)

      await this.fetchCursos()
      this.$router.push('/profesionalizacion/cursos')
      this.loading = false
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0]
      console.log(this.$refs.file.files[0])
    },
  },
}
</script>

<style scoped>
.ui-back-btn {
  color: #26de81 !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 210, 160, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(0, 210, 160, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field textarea,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .v-file-input__text,
::v-deep .ui-form-field .mdi-menu-down,
::v-deep .ui-form-field .mdi-paperclip {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field .v-label--active {
  color: #26de81 !important;
}

::v-deep .ui-form-field .v-text-field__details,
::v-deep .ui-form-field .v-messages__message {
  color: rgba(224, 224, 224, 0.55) !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .ui-module-actions .ui-module-btn-solid {
  background: linear-gradient(135deg, #00d2a0 0%, #26de81 100%) !important;
  color: #062118 !important;
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.28) !important;
}

::v-deep .ui-module-actions .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 210, 160, 0.25) !important;
}

.red--text {
  color: #ff5252 !important;
}
</style>
